
import React from 'react';
import { selectSeverity, unSelectSeverity } from '@store/aiAlerts/summary/actions';
import { selectedSeveritiesSelector } from '@store/aiAlerts/summary/selectors';
import { useSelector, useDispatch } from 'react-redux';
import {
  Wrapper, TagName, TagValue,
} from './styled';

const SeverityTag = ({ tag, value }) => {
  const dispatch = useDispatch();
  const selectedTags = useSelector(selectedSeveritiesSelector);
  const isSelected = selectedTags.includes(tag.key);

  const onClickOfTag = () => {
    const isTagSelected = selectedTags.includes(tag.key);
    if (isTagSelected) {
      dispatch(unSelectSeverity(tag.key));
    } else {
      dispatch(selectSeverity(tag.key));
    }
  };

  return (
    <Wrapper isSelected={isSelected} onClick={onClickOfTag}>
      <TagName>{tag.title}</TagName>
      <TagValue style={{ color: tag.color }} className="color-critical">
        {value}
      </TagValue>
    </Wrapper>
  );
};

export default SeverityTag;
